import React, { useEffect, useState } from "react";
import AdminHeader from "../../../Components/AdminComponent/AdminHeader/AdminHeader";
import AdminSidebar from "../../../Components/AdminComponent/AdminSidebar/AdminSidebar";
import AddPromotionalBannerComponent from "../../../Components/AdminComponent/AddPromotionalBannerComponent/AddPromotionalBannerComponent";
import { Apiurl, GetLocalStorageParsed, parseData } from "../../utils/page";
import axios from "axios";
import { toast } from "react-toastify";

const AddPromotionalBanner = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [bannerData, setBannerData] = useState();
  const[viewDataModal,setViewDataModal]=useState(false);
  const[bannerAnalyticData,setBannerAnalyticData]=useState();
  const[changePointModal,setChangePointModal]=useState(false);
  const [clickedBannerData,setClickedBannerData]=useState();
  const [impressionForm,setImpressionForm]=useState();


  const getAllBanner = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Admin/GetBanner`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setBannerData(data);
      })
      .catch((error) => {});
  };

  const handleBannerAnalytics = (e) => {
    const data = {
      Id: e,
    };

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Admin/BannerAnalytics`,
    };
    axios(options)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setBannerAnalyticData(data);

       
      })
      .catch((error) => {});
  };
  const handleUpdateBannerImpression = (e) => {
    const data = {
      Id: clickedBannerData?.Id,
      RemainingImpression:impressionForm
    };

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Admin/UpdateBannerImpression`,
    };
    axios(options)
      .then((e) => {
          if (e?.data?.status === "OK") {
                  toast.success(e?.data?.message);
                }
                if (e?.data?.status === "BadRequest") {
                    toast.error(e?.data?.message);
                  }
        getAllBanner();
        setChangePointModal(false)
        setImpressionForm()
       
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getAllBanner();
  }, []);
  const handleCloseViewDataModal=()=>{
    setViewDataModal(false)
  }
  const handleCloseChangePointModal=()=>{
    setChangePointModal(false)
  }

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <AdminHeader />
      <div className="row col-lg-12">
        <AdminSidebar />
        <div className="col-lg-10 right_content">
          <AddPromotionalBannerComponent bannerData={bannerData} handleBannerAnalytics={handleBannerAnalytics}
          setViewDataModal={setViewDataModal}
          viewDataModal={viewDataModal}
          handleCloseViewDataModal={handleCloseViewDataModal}
          bannerAnalyticData={bannerAnalyticData}
          setChangePointModal={setChangePointModal}
          handleCloseChangePointModal={handleCloseChangePointModal}
          changePointModal={changePointModal}
          setClickedBannerData={setClickedBannerData}
          setImpressionForm={setImpressionForm}
          impressionForm={impressionForm}
          handleUpdateBannerImpression={handleUpdateBannerImpression}
          />
        </div>
      </div>
    </div>
  );
};

export default AddPromotionalBanner;
